import request from "@/utils/request";
import Qs from "qs";

// 获取房屋类型列表
export function openHouseTypeLists(data) {
  return request({
    url: "/common/get_house_type_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 楼栋列表
export function getSpaceList(data) {
  return request({
    url: "/space/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 导入楼栋和房间
export function spaceImport(data) {
  return request({
    url: "/space/import",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 导出楼栋、房间、关联的企业
export function spaceExport(data) {
  return request({
    url: "/space/export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}

// 导出模板
export function spaceTemplate(data) {
  return request({
    url: "/space/template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加楼栋
export function addSpace(data) {
  return request({
    url: "/space/add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑楼栋
export function editSpace(data) {
  return request({
    url: "/space/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看楼栋
export function seeSpace(data) {
  return request({
    url: "/space/info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除楼栋
export function delSpace(data) {
  return request({
    url: "/space/del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 房间列表
export function house_lists(data) {
  return request({
    url: "/space/house_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加房间
export function addHouse(data) {
  return request({
    url: "/space/house_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑房间
export function editHouse(data) {
  return request({
    url: "/space/house_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看房间
export function seeHouse(data) {
  return request({
    url: "/space/house_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除房间
export function delHouse(data) {
  return request({
    url: "/space/house_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
